<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-50 py-12">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700" @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto px-4 max-w-6xl">

        <h1 class="font-bold  text-xl">{{ $t('label.completar') }}</h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.nombre') }}</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.nombre')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.apellido') }}</label>
            <Field name="apellido" v-slot="{ field,errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.apellido')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.documento') }}</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.documento')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.nacionalidad') }}</label>
            <Field name="nacionalidad" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.nacionalidad">
              <Dropdown @blur="handleBlur" filter @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" :placeholder="$t('global.seleccione.opcion')" class="input-base" :options="translatedCountries" optionLabel="value" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nacionalidad" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.cargo') }}</label>
            <Field name="cargo" v-slot="{ field,errors }" v-model="formData.cargo">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.cargo')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.empresa') }}</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.empresa')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-8/12">
            <label class="block mb-1">{{ $t('label.mail') }}</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" class="input-base" :placeholder="$t('label.mail')" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.fecha.nacimiento') }}</label>
            <Field name="fechaNacimiento" v-slot="{ field, errors }" v-model="formData.fechaNacimiento">
              <InputMask v-bind="field" mask="99/99/9999" placeholder="dd/mm/yyyy" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="fechaNacimiento" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
              <label class="block mb-1">{{ $t('label.pais') }}</label>
              <Dropdown v-model="selectedCountry" filter :options="translatedCountries" optionLabel="value" placeholder="Select a Country" class="input-base"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">{{ $t('label.codigoPais') }}</label>
            <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.code" class="input-base" readonly />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">{{ $t('label.codigoArea') }}</label>
            <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.celular') }}</label>
            <Field name="numeroTelefono" v-slot="{ field, errors }" v-model="formData.numeroTelefono">
              <InputText v-bind="field" type="text" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="numeroTelefono" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3 jusi">
          <button type="submit" label="REGISTRARME"
            class="mt-8 px-4 py-2 bg-transparent border-blue-950 hover:bg-cyan-600 text-blue-950 font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>{{ $t('global.registrarme') }}
          </button>
        </div>
      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />
      
    </Form>

  </section>
</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import BlockUI from 'primevue/blockui';
import HeaderSection from '@/components/HeaderSection.vue'
import InputMask from 'primevue/inputmask';

import jsonCountries from '@/data/countries.json';

import suiteService, { Acreditado, EstadoAcreditado, OrigenAcreditado, TipoAcreditado } from 'qreventos-suite/services';
import {  SAVE, ORIGEN_ACREDITADO, A_VERIFICAR } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';

interface Pais {
  code: string;
  value: string;
}

export default defineComponent({
  name: 'FormSection',
  components: {
    HeaderSection,
    InputText, Dropdown, InputMask,
    Field, ErrorMessage, Form, BlockUI
  },
  data() {
    return {
      isSubmitting: false,
      paises: jsonCountries as Pais[],
      selectedCountry: {"code": "+54", "value": "Argentina"} as Pais,
      formData: {     
        nombre: '',
        apellido: '',
        dni: '',
        nacionalidad : undefined as unknown as Pais,
        codigoArea: '',
        numeroTelefono: '',
        mail: '',
        fechaNacimiento:'',
        cargo :'',
        empresa : ''
      }
    };
  }, 
  computed: {
    schema() {
      return yup.object({
        nombre: yup.string().required(this.$t('errors.name.required')).min(3, this.$t('errors.name.min')),
        apellido: yup.string().required(this.$t('errors.lastname.required')).min(3, this.$t('errors.lastname.min')),
        dni: yup.string().required(this.$t('errors.dni.required')).min(6, this.$t('errors.dni.min')),
        nacionalidad: yup.object().required(this.$t('errors.nationality.required')),
        codigoArea: yup.string().required(this.$t('errors.areaCode.required')).matches(/^\d+$/, this.$t('errors.areaCode.numeric')),
        numeroTelefono: yup.string().required(this.$t('errors.phone.required')).matches(/^\d+$/, this.$t('errors.phone.numeric')),
        mail: yup.string().required(this.$t('errors.email.required')).email(this.$t('errors.email.invalid')),
        fechaNacimiento: yup.string().required(this.$t('errors.fecha.nacimiento.required')).matches(
    /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
    this.$t('errors.fecha.nacimiento.formato')
  ),
        empresa: yup.string().required(this.$t('errors.empresa.required')).min(3, this.$t('errors.empresa.min')),
        cargo: yup.string().required(this.$t('errors.cargo.required')).min(3, this.$t('errors.cargo.min')),
      });
    },
    translatedCountries() {
      return this.paises.map(pais => ({
        ...pais,
        value: this.$t(pais.value) // Traducir el valor usando la función $t()
      }));
    },
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores:number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: this.$t("error.revise") + " " + errores, icon: "error"});
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente:Acreditado[] =  await suiteService.findAcreditadosByFilters(suiteConfig.evento, "dni="+encodeURIComponent(this.formData.dni) ) ;
        if (acreditadoExistente.length > 0) {
            this.isSubmitting = false;
              Swal.fire({ title: "Atención",  html: this.$t('error.ya.registrado'), icon: "warning" }).then(() => {
                    this.isSubmitting = false;
              });
              return;
        }

        const acreditado:Acreditado = {} as Acreditado;
        
        acreditado.tipoAcreditado = { "id" : 1316 } as TipoAcreditado,
        acreditado.estadoAcreditado = { "id": A_VERIFICAR } as EstadoAcreditado;
        acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
        acreditado.nombre = this.formData.nombre;
        acreditado.apellido = this.formData.apellido;
        acreditado.dni = this.formData.dni;
        acreditado.dato1 = this.formData.nacionalidad.value;
        acreditado.cargo = this.formData.cargo;
        acreditado.empresa = this.formData.empresa;
        acreditado.mail = this.formData.mail;
        acreditado.fechaNacimiento = this.formData.fechaNacimiento;
        acreditado.telefono = this.selectedCountry.code + this.formData.codigoArea + this.formData.numeroTelefono;
        acreditado.cantidad = 1;
        acreditado.notificar = true;
        acreditado.modificado = SAVE;
        acreditado.datos = {} as any;

        const acreditadoActualizado: Acreditado = await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

    
        if (acreditadoActualizado) {
          this.isSubmitting = false;
          Swal.fire({ title: this.$t("label.titulo.success"), html: this.$t("label.message.success"), icon: "success" }).then(() => {
              this.$router.go(0);
          });
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },
  }
});
</script>